// src/pages/Signup.jsx
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { createUserWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../firebaseConfig";
import "./Auth.css";

function Signup() {
  const navigate = useNavigate();
  const location = useLocation();

  // ================================
  // READ REDIRECT PARAM
  // ================================
  const params = new URLSearchParams(location.search);
  const redirect = params.get("redirect") || "/";

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ================================
  // NORMAL EMAIL SIGNUP
  // ================================
  const handleSignup = async (e) => {
    e.preventDefault();

    if (!form.name.trim()) return alert("Enter your name!");
    if (!form.email.trim()) return alert("Enter your email!");
    if (!form.password.trim()) return alert("Enter a password!");

    setLoading(true);

    try {
      await createUserWithEmailAndPassword(auth, form.email, form.password);

      alert("Signup successful!");

      // REDIRECT BACK TO PRODUCT PAGE
      navigate(redirect);

    } catch (err) {
      console.error(err);
      alert(err.message);
    }

    setLoading(false);
  };

  // ================================
  // GOOGLE SIGNUP
  // ================================
  const handleGoogleSignup = async () => {
    setLoading(true);

    try {
      await signInWithPopup(auth, googleProvider);

      alert("Signed up with Google!");

      // Redirect back to where user was
      navigate(redirect);

    } catch (err) {
      console.error(err);
      alert(err.message || "Google sign-in failed");
    }

    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Create Account</h2>

        <form onSubmit={handleSignup}>
          <label>
            Full Name
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Your Name"
            />
          </label>

          <label>
            Email Address
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="you@example.com"
            />
          </label>

          <label>
            Password
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="********"
            />
          </label>

          <button className="auth-btn" type="submit" disabled={loading}>
            {loading ? "Creating Account..." : "Signup"}
          </button>
        </form>

        <button
          onClick={handleGoogleSignup}
          className="auth-btn"
          style={{ background: "#4285F4", marginTop: "10px" }}
          disabled={loading}
        >
          Continue with Google
        </button>

        <p className="auth-switch">
          Already have an account? <a href="/login">Login</a>
        </p>
      </div>
    </div>
  );
}

export default Signup;
